import { render } from "./AppMainBlock.vue?vue&type=template&id=b13d82dc&scoped=true"
import script from "./AppMainBlock.vue?vue&type=script&lang=js"
export * from "./AppMainBlock.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13d82dc"]])

export default __exports__